import axios from "axios";
import _ from "lodash";
import { INSTANCE_URL } from "Constants";
import { getHeaders } from "CommonUtils";
import {
  getRequest,
  postRequest,
  deleteRequest,
  patchRequest,
} from "NetworkCall";

export var FETCH_LOCATION_MAPS = "FETCH_LOCATION_MAPS";
export var SHOW_LOCATION_MAP_MODAL = "SHOW_LOCATION_MAP_MODAL";
export var LOCATION_MAP = "LOCATION_MAP";
const STATIC_MAP_BASE_URL =
  "https://maps.googleapis.com/maps/api/staticmap?zoom=14&size=400x300&center=";

export function fetchLocationMaps(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/locationmaps?filter=eventid=${session.eventid}&order=createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: FETCH_LOCATION_MAPS, payload: data.resource });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function locationDetails(session, params, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=location_details`;
  var response = axios.post(url, params, getHeaders(session));
  return (dispatch) => {
    response.then(({ data }) => {
      if (data.result.length > 0) callback(data.result[0]);
      else {
        callback(null);
      }
    });
  };
}

export function geocode_coords(session, params, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=geocode_location`;
  var response = axios.post(url, params, getHeaders(session));
  return (dispatch) => {
    response.then(({ data }) => {
      if (data.result.length > 0) callback(data.result[0]);
      else {
        callback(null);
      }
    });
  };
}

export function openLocationMapModal(showModal) {
  return { type: SHOW_LOCATION_MAP_MODAL, payload: showModal };
}

export function deleteLocationMap(session, locationmap, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/locationmaps/${locationmap.mapid}`;

  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ error: 0, data: data });
        dispatch(fetchLocationMaps(session, (callback) => {}));
      },
      (error) => {
        callback({ error: 1, error: error });
      }
    );
  };
}

export function insertLocationMap(session, locationmap, callback) {
  var center = `${locationmap.latitude},${locationmap.longitude}`;
  var params = {
    center,
    eventid: session.eventid,
  };
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/uploadmapthumb`;
  var response = axios.post(url, params, getHeaders(session));
  return (dispatch) => {
    response.then(({ data }) => {
      data = data.result[0].content.resource[0];
      var thumbimagepath = data.path;
      locationmap = { resource: { ...locationmap, thumbimagepath } };
      var url = `${INSTANCE_URL}/api/v2/eventify/_table/locationmaps/`;
      postRequest(
        url,
        locationmap,
        session,
        dispatch,
        (response) => {
          callback({ success: 1 });
          dispatch(fetchLocationMaps(session, (callback) => {}));
          dispatch(openLocationMapModal(false));
        },
        (error) => {
          callback({ success: 0, message: error });
        }
      );
    });
  };
}

export function editLocationMap(locationmap) {
  return (dispatch) => {
    dispatch({ type: LOCATION_MAP, payload: locationmap });
    dispatch(openLocationMapModal(true));
  };
}

export var updateLocationMap = (session, locationmap, callback) => {
  var center = `${locationmap.latitude},${locationmap.longitude}`;
  var params = {
    center,
    eventid: session.eventid,
  };
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/uploadmapthumb`;
  var response = axios.post(url, params, getHeaders(session));
  return (dispatch) => {
    response.then(({ data }) => {
      data = data.result[0].content.resource[0];
      var thumbimagepath = data.path;
      var mapid = locationmap.mapid;
      locationmap = {
        resource: { ...locationmap, thumbimagepath, eventid: session.eventid },
      };

      var url = `${INSTANCE_URL}/api/v2/eventify/_table/locationmaps/`;
      patchRequest(
        url,
        locationmap,
        session,
        dispatch,
        (response) => {
          callback({ success: 1 });
          dispatch(fetchLocationMaps(session, (callback) => {}));
          dispatch(openLocationMapModal(false));
        },
        (error) => {
          callback({ success: 0, message: error });
        }
      );
    });
  };
};
